module.exports = __webpack_public_path__ + "media/categories/factory-fe5a12da.png";